import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminService {

  constructor(private http: HttpClient) { }

    //  *---------------Super Admin Client-----------------*
    getClientList(body, is_export: boolean = false) {
      if(is_export){
        return this.http.post(environment.baseApiUrl + `master/v1/client/filter/list`, body, { observe: 'response', responseType: 'blob' });
      }else{
      return this.http.post<any>(environment.baseApiUrl + `master/v1/client/filter/list`, body);
      }
    }
    postClient(body: {}) {
      return this.http.post(environment.baseApiUrl + 'master/v1/client', body);
    }
    deleteClient(id) {
      return this.http.delete(environment.baseApiUrl + `master/v1/client/${id}`);
    }
    updateClient(body: {}, id) {
      return this.http.put(environment.baseApiUrl + `master/v1/client/${id}`, body);
    }
}
